import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { Check } from "lucide-react";
import { CHECK_SUCCESS } from "../../../../../assets";

interface PaymentSuccessModalProps {
  open: boolean;
  close: () => void;
  onViewReceipt: () => void;
}

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({
  open,
  close,
  onViewReceipt,
}) => {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-full max-w-md"
      edges="rounded-2xl"
    >
      <div className="flex flex-col bg-white p-8 items-center text-center">
        {/* Success Icon */}
        <img src={CHECK_SUCCESS} className="w-[94px] h-[94px]" alt="" />

        <h2 className="text-xl font-bold text-[#1A1A1A] mb-8">
          Payment successful
        </h2>

        <div className="flex items-center gap-x-4 w-full">
          <button
            onClick={close}
            className="flex-1 bg-[#00B074] text-white py-3 rounded-lg font-medium hover:bg-[#009b65] transition-colors"
          >
            Close
          </button>
          <button
            onClick={onViewReceipt}
            className="flex-1 bg-[#BDE0CE] text-[#1A1A1A] py-3 rounded-lg font-medium hover:bg-[#a6d1bb] transition-colors"
          >
            View receipt
          </button>
        </div>
      </div>
    </ModalV2>
  );
};

export default PaymentSuccessModal;
